<template>
<div>
  <span class="addContactButton">
    <va-button
      @click.prevent="newReference()">
        {{ $t('references.add') }}
    </va-button>
  </span>

  <Breadcrumbs
    :breadcrumbs="[
      { title: this.$t('menu.wellbeing'), disabled: true },
      { title: this.$t('menu.wellbeing/contacts'), disabled: true }
    ]">
    <span slot="breadcrumbAfter" class="d-flex">
        <!--<Searchable
          :querySearch.sync="querySearch"
        />-->
      <Filters
        :isActive="showExtraFilters"
        :activeFilters="activeFilters"
        @toggle-filters="toggleShowExtraFilters"
      />
      </span>
  </Breadcrumbs>

  <div class="buttonSpace">
    <div v-if="showExtraFilters" class="evollu-form">
      <div class="row">
        <div class="col-12 col-md-4">
          <RangeDatePicker v-model="filters.dateRange">
            <div slot="label">
              <label class="form-label" style="margin-top: -3px;">
                {{ $t('statistics.daterange_start') }}
                <span class="clickable" :class="{'unselectedDateLabel': filters.dateType != 'createdAt', 'selectedDateLabel': filters.dateType == 'createdAt'}" @click="filters.dateType = 'createdAt'">{{ $t('statistics.daterange_created_at') }}</span>
                <span class="dateSeparatorLabel">/</span>
                <span class="clickable" :class="{'unselectedDateLabel': filters.dateType != 'updatedAt', 'selectedDateLabel': filters.dateType == 'updatedAt'}" @click="filters.dateType = 'updatedAt'">{{ $t('statistics.daterange_updated_at') }}</span>
                {{ $t('statistics.daterange_end') }}:
              </label>
            </div>
          </RangeDatePicker>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label">{{$t('users.inputs.entity')}}</label>
          <multiselect
            v-model="filters.entities"
            :options="entityOptions"
            track-by="uid"
            :custom-label="formatedEntityLabel"
            label="name"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :searchable="true"
            :allow-empty="true"
            :multiple="true"
            :limit="2"
          >
            <span slot="noResult">{{$t('patients.noResults')}}</span>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="filters.entities.length" @mousedown.prevent.stop="filters.entities = []"></div>
            </template>
          </multiselect>
        </div>

        <!--<div class="col-12 col-md-4">
          <label class="form-label">{{ $t('leads.table.status') }}</label>
          <multiselect
            v-model="filters.statuses"
            :options="statuses"
            track-by="id"
            label="name"
            :custom-label="status => $t(status.name)"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :searchable="true"
            :allow-empty="true"
            :multiple="true"
            :limit="3"
          >
            <span slot="noResult">{{$t('patients.noResults')}}</span>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="filters.statuses.length" @mousedown.prevent.stop="filters.statuses = []"></div>
            </template>
          </multiselect>
        </div>-->



      </div>
    </div>
    <v-server-table
      :key="tableKey"
      id="contactsTable"
      ref="contactsTable"
      name="contactsTable"
      :columns="columns"
      :options="tableOptions"
      @row-click="onClickRow"
    >
      <span slot="name" slot-scope="props">
        <span v-if="props.row.surname">
          {{ props.row.name + ' ' + props.row.surname | capitalize }}
        </span>
        <span v-if="!props.row.surname">
          {{ props.row.name | capitalize }}
        </span>
      </span>
      <span slot="email" slot-scope="props">
        {{ props.row.email ? props.row.email : $t('references.unspecified') }}
      </span>
      <span slot="phone" slot-scope="props">
        {{ props.row.phone ? props.row.phone : $t('references.unspecified') }}
      </span>
      <span slot="status" slot-scope="props">
        {{ getStatusById(props.row.status.id) }}
      </span>

      <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="updatedAt" class="no-break" slot-scope="props">{{ props.row.updatedAt | localTime('YYYY-MM-DD HH:mm') }}</span>


    </v-server-table>
  </div>



  <ContactForm
    v-if="showEditModal"
    :entities="entitiesRead"
    :service="component.service"
    :facilitiesWrite="facilitiesWrite"
    :facilitiesRead="facilitiesRead"
    :entitiesWrite="entitiesWrite"
    :editingLead="editingLead"
    @close-contact-modal="closeContactModal"
    @update-table="updateTable">
  </ContactForm>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContactForm from './ContactForm.vue'
import Multiselect from 'vue-multiselect'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import { TABLE_WELLBEING_CONTACTS } from '@/local-storage/LocalStorageKeys'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import Searchable from '@/components/common/Searchable'
import Filters from '@/components/common/Filters'

const contactsInfoType = 110

export default {
  components: {
    Filters,
    Searchable,
    Multiselect,
    ContactForm,
    Breadcrumbs,
    RangeDatePicker
  },
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  mixins: [
    MultiselectLabelFormatter,
    TableQueryMixin,
    ClustersAndEntitiesMixin,
    IndexTablesMixin
  ],
  data () {
    return {
      tableKey: 0,
      querySearch: '',
      customQueries: {},
      localStorageKey: TABLE_WELLBEING_CONTACTS,
      leads: [],
      editingLead: null,
      labels: [],
      isloading: false,
      errorMsg: null,
      showEditModal: false,
      show: true,
      showDeleteConfirmation: false,
      deletedReason: '',
      showConsentModal: false,
      canClose: false,
      showExtraFilters: false,
      pageCount: 0,
      page: 1,
      queryUrl: `${this.component.service.url}/v1/leads`,
      tableOptions: {
        filterable: ['updatedAt', 'createdAt', 'name', 'entity'],
        customFilters: ['statuses', 'entities', 'start', 'end', 'date'],
        sortable: ['updatedAt', 'name', 'email', 'createdAt'],
        headings: {
          name: this.$t('references.table.name'),
          phone: this.$t('references.table.phone'),
          email: this.$t('references.table.email'),
          'entity.name': this.$t('references.table.entity'),
          createdAt: this.$t('references.table.created_at'),
          status: this.$t('references.table.status'),
          updatedAt: this.$t('leads.table.updated_at')
        },
        columnsDropdown: true,
        columnsDisplay: {
          name: 'min_mobile',
          phone: 'min_tablet',
          email: 'desktop',
          status: 'min_tablet',
          updatedAt: 'min_mobile'
        },
        columnsClasses: {
          name: 'name',
          phone: 'phone',
          email: 'email',
          entity: 'entity',
          status: 'status',
          info: 'info',
          updatedAt: 'updated_at',
          createdAt: 'updated_at'
        },
        saveState: true,
      },
      filters: {
        querySearch: null,
        dateType: 'createdAt',
        entities: [],
        statuses: [],
        dateRange: {
          start: null,
          end: null
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'wellbeing/statuses',
      clusters: 'clusters'
    }),
    columns: function () {
      return ['createdAt', 'updatedAt', 'name', 'phone', 'email', 'entity.name']
    },
    columnsDisplayedByDefault: function () {
      return ['createdAt', 'updatedAt', 'name', 'phone', 'email', 'entity.name']
    },
    wellbeingService: function () {
      return this.component.service
    },
    referencesReadPermissions: function () {
      return this.wellbeingService.user_permissions.filter(p => p.info_type === contactsInfoType)
    },
    referencesWritePermissions: function () {
      return this.referencesReadPermissions.filter(p => p.access_type >= 2)
    },
    entitiesRead: function () {
      return this.wellbeingService.entities.filter(entity => this.referencesReadPermissions.some(p => p.entity_id === null || p.entity_id === entity.id))
    },
    entitiesWrite: function () {
      return this.wellbeingService.entities.filter(entity => this.referencesWritePermissions.some(p => p.entity_id === null || p.entity_id === entity.id))
    },
    facilitiesWrite: function () {
      return this.entitiesWrite.map(entity => entity.facilities).flat()
    },
    facilitiesRead: function () {
      return this.entitiesRead.map(entity => entity.facilities).flat()
    },
    activeFilters: function () {
      let nr = this.filters.entities.length + this.filters.statuses.length
      if (this.filters.dateRange !== null && this.filters.dateRange.start !== null && this.filters.dateRange.end !== null) nr += 1
      return nr
    },
    entityOptions: function () {
      return this.createClustersAndEntitiesList(this.clusters, this.entitiesRead)
    }
  },
  methods: {
    showOrHideColumns: function () {
      let state = LocalStorageHelper.get(TABLE_WELLBEING_CONTACTS)
      if (state) {
        let displayedColumns = state.userColumnsDisplay || this.columnsDisplayedByDefault
        this.columns
          .filter(column => !displayedColumns.includes(column))
          .forEach(column => this.$refs.contactsTable.toggleColumn(column))
      }
    },
    onClickRow: function ({ row }) {
      this.editingLead = row
      this.showEditModal = true
    },
    getStatusById: function (id) {
      let status = this.statuses.find(status => status.id === parseInt(id))
      return status ? this.$t(status.name) : null
    },
    closeContactModal: function () {
      this.showEditModal = false
      this.editingLead = null
    },
    toggleShowExtraFilters: function () {
      this.showExtraFilters = !this.showExtraFilters
    },
    hideExtraFilters: function () {
      this.showExtraFilters = false
    },
    updateTable (updatedData) {
      /*this.closeContactModal()
      console.log(updatedData)
      let elemIdx = this.$refs.contactsTable.data.findIndex(elem => parseInt(elem.id) === parseInt(updatedData.data.id))
      if (elemIdx !== null && elemIdx !== undefined) {
        this.$refs.contactsTable.data[elemIdx] = updatedData.data
      }*/
      this.$refs.contactsTable.refresh()
    },
    canShowConsent (id) {
      return this.entitiesWrite.some(e => e.id === id)
    },
    newReference () {
      this.showEditModal = true
    },


    loadFiltersLocalStorage: function () {
      const state = LocalStorageHelper.get(TABLE_WELLBEING_CONTACTS)
      if (state) {
        Object.values(state.customQueries).some(object => {
          console.log(object)
        })
        if (Object.values(state.customQueries).some(object => object !== null && object !== '')) {
          this.showExtraFilters = true

          if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids) {
            this.filters.entities = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityUids)
          }

          if (state.customQueries.statuses && state.customQueries.statuses !== '') {
            const selectedStatuses = state.customQueries.statuses.split(',').map(element => parseInt(element))
            this.filters.statuses = this.statuses.filter(status => selectedStatuses.includes(status.id))
          }

          if (state.customQueries.date !== '') {
            this.filters.dateType = state.customQueries.date
          }

          if (state.customQueries.start !== '' && state.customQueries.end !== '') {
            this.filters.dateRange = {
              start: state.customQueries.start,
              end: state.customQueries.end
            }
          }
        }
      }
    },
    writableEntity: function (entityId) {
      for (var i = 0; i < this.entitiesWrite.length; i++) {
        if (this.entitiesWrite[i].id === entityId) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    'filters.statuses': function (statuses) {
      const selectedStatuses = statuses.map(status => status.id).join(',')
      this.emitTableFilter('vue-tables.contactsTable.filter::statuses', selectedStatuses)
    },
    'filters.entities': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.emitTableFilter('vue-tables.contactsTable.filter::entities', Array.from(selectedOptions.ids).join(','))
      this.$nextTick(() => {
        let state = LocalStorageHelper.get(TABLE_WELLBEING_CONTACTS)
        state.selectedEntityUids = Array.from(selectedOptions.uids)
        console.log(state)
        LocalStorageHelper.set(TABLE_WELLBEING_CONTACTS, state)
      })
    },
    'filters.dateRange': function (dateRange) {
      this.$refs.contactsTable.customQueries.start = dateRange ? dateRange.start : null
      this.emitTableFilter('vue-tables.contactsTable.filter::end', dateRange ? dateRange.end : null)
    },
    'filters.dateType': function (dateType) {
      this.emitTableFilter('vue-tables.contactsTable.filter::date', dateType)
    },
    'filters.querySearch': function (value) {
      this.$refs.contactsTable.setFilter(value)
      this.$emit('filters-updated', { filters: this.filters, count: this.activeFilterCount })
    },
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      }
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
    }
  },
  mounted () {
    this.loadFiltersLocalStorage()
    this.showOrHideColumns()
  }
}
</script>

<style lang="scss">

.no-break {
  white-space: nowrap;
}

.btn.btn-primary.btn-cancelar {
  background-color: #fff;
  color: #29c4a9;
}

.toasted.outline.success {
  color: #29c4a9 !important;
  border-color: #29c4a9 !important;
  box-shadow: 0 4px 9.6px 0.4px #29c4a9 !important;
}

.badge-consent{
  cursor: pointer;
  font-weight: bold;
}

.fa.fa-exclamation-triangle {
  color: red;
}

input.circleInput{
 width: 80px;
 line-height: 80px;
 border-radius: 40px;
 font-size: 40px;
 border-color: #A49D97;
 text-align: center;
 border-style: solid;
 transition: 1s;
}

input:focus.circleInput{
    outline: none;
    border-color: #29c4a9;
}

input[type='number'] {
    -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.separator{
  font-size: 50px;
  margin: 5px;
}

.invalid {
  border-color: #e34a4a;
}

.valid{
  border-color: #29c4a9;
}

.validCode{
  border-color: #29c4a9 !important;
}

.invalidInput{
  border-color: red;
}

.verification{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
  margin-bottom: 2em;
}

ul{
  z-index: 5;
}

[tel]{
  outline: none !important;
}

.fa-print{
  color: #29c4a9;
  font-size: 1.2em;
  cursor: pointer;
}

#contactsTable .verified {
  color: $evollu-dark !important;
}

#contactsTable .not-verified {
  color: $theme-danger !important;
}

#contactsTable .fa-pencil {
  color: $evollu-dark !important;
}

#contactsTable tbody tr:hover .fa-pencil {
  color: white !important;
}

#contactsTable i {
  padding-right: 2px;
  padding-left: 2px;
}

#contactsTable .VueTables__sortable {
  cursor: pointer;
}

#contactsTable th.name {
  min-width: 90px;
}

#contactsTable th.updated_at {
  min-width: 110px;
}

#contactsTable th.info {
  min-width: 85px;
}

#contactsTable th.status {
  min-width: 90px;
}

.unselectedDateLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: line-through !important;
}

.dateSeparatorLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.selectedDateLabel {
  font-size: 0.6rem !important;
  color: #29c4a9 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.sort-icon-class {
  cursor: pointer;
}

.addContactButton {
  position: fixed;
  right: 20px;
  bottom: 40px;
  z-index: 3;
}

.buttonSpace {
  @media only screen and (max-width: 768px) {
    margin-bottom: 80px !important;
  }
}

</style>
